import React from 'react';

import Modal from '../../Modal';
import DeleteIcon from '../../../images/donation/delete_box.svg';

const DeleteProjectDonationModel = ({ open, onClose, onConfirmDelete, projectName }) => {
  const handleDelete = () => {
    onConfirmDelete();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} sx={{ maxWidth: '900px' }}>
      <div className="project-deletion-modal">
        <div className="project-deletion-modal-container">
          <div className="donation-project-img">
            <img src={DeleteIcon} />
          </div>
          <h2 className="donation-project-msg">Are you sure you want to delete donation for {projectName}?</h2>
          <div className="donation-modal-body">
            <p className="donation-project-descriptions">
              We acknowledge your decision to cancel your donation to Lineage. Please understand that this may affect
              the advancement of our projects. Should you have any questions or concerns, our dedicated support team is
              available to assist you promptly
            </p>

            <div className="btn-group donation-project-button">
              <button className="btn btn-md btn-outline" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn-md btn-primary-ii" onClick={handleDelete}>
                Yes
              </button>
            </div>
            <div>
              <p style={{ textAlign: 'center', marginTop: '64px', color: '#656565' }}>
                © Lineage Journey {new Date().getFullYear()}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteProjectDonationModel;
